const myAccount = {
  title: {
    customerAccount: 'Kundenkonto',
    logout: 'Abmelden',
  },
  userDataContainer: {
    userData: 'Benutzerdaten',
    edit: 'Bearbeiten',
    customerNumber: 'Kundennummer',
    changePassword: 'Passwort ändern',
    yourAccount: 'Ihr Konto',
  },
  lastOrders: 'Letzte Bestellungen',
  noOrders: {
    title: 'Bestellungen',
    neverOrdered: 'Sie haben noch nie über dieses IhreApotheken-Konto bestellt.',
    usePharmacy: 'Stellen Sie sicher, dass Sie bei der Bestellung Ihr IhreApotheken-Konto benutzen, um ganz einfach nachbestellen zu können.',
    orderNow: 'Jetzt bestellen',
  },
  editUserData: {
    updateAccount: 'Kundenkonto aktualisieren',
    updateOrComplete: 'Hier können Sie Ihre Nutzerdaten aktualisieren oder vervollständigen.',
    successfullyUpdatedMessage: 'Ihre Kontaktdaten wurden erfolgreich geändert',
    yourEmail: 'Ihre E-Mail-Adresse',
    changeEmail: 'E-Mail ändern',
    changePassword: 'Passwort ändern',
    changePasswordDescription: 'Sie möchten ein neues Passwort vergeben?',
    dataSharingLabel: 'Datenfreigabe für Apotheken',
    dataSharingManagePermissions: 'Freigaben verwalten',
    deleteAccountQuestion: 'Sie möchten Ihr Konto bei IhreApotheken.de vollständig löschen? Dann klicken Sie hier und prüfen Sie anschließend Ihre E-Mails zur Bestätigung.',
    deleteAccount: 'Konto löschen',
    deleteAccountEmailSent: 'Wir haben eine E-Mail an Ihr Postfach gesendet. Diese enthält einen Link, den Sie anklicken müssen, um Ihren Account bei IhreApotheken.de vollständig zu löschen.',
    maxTriesEmail: 'Sie haben die maximale Anzahl an Änderungsversuchen erreicht. Bitte kontaktieren Sie unseren Kundenservice',
    here: 'hier',
    changeEmailAddress: 'E-Mail-Adresse ändern',
    emailChangeNote: 'Hier können Sie die in Ihrem IhreApotheken.de-Kundenkonto hinterlegte E-Mail-Adresse ändern. Bitte beachten Sie, dass auch alle Benachrichtungen zu Bestellungen an Ihre E-Mail-Adresse gesendet werden.',
    newEmail: 'Neue E-Mail-Addrese',
    currentPassword: 'Derzeitiges Passwort',
    forgotPassword: 'Passwort vergessen?',
    cancel: 'Zurück',
    howToChange: 'So ändern Sie Ihre E-Mail-Adresse:',
    enterEmail: 'Bitte geben Sie Ihre neue E-Mail-Adresse ein und bestätigen Sie diese mit Ihrem aktuellen Passwort. Klicken Sie dann auf "E-Mail ändern".',
    receiveVerification: 'Sie erhalten von uns eine Verifizierungs-E-Mail.',
    afterVerify: 'Nachdem Sie Ihre neue E-Mail-Adresse verifiziert haben, können Sie sich in Ihrem IhreApotheken-Konto anmelden.',
    emailSent: 'E-Mail gesendet!',
    emailWasSentTo: 'Eine E-Mail wurde an ',
    linkToVerify: ' gesendet. Diese enthält einen Link, den Sie anklicken müssen, um Ihr neue E-Mail-Addresse zu verifizieren. Bitte prüfen Sie im Zweifel auch den Spam-Ordner.',
    emailChanged: 'Ihre E-Mail-Adresse wurde erfolgreich geändert!',
    youCanRegister: 'Sie können sich ab sofort mit ',
    atIa: ' bei IhreApotheken.de anmelden.',
    toYourPharmacy: 'zu ihrer apotheke',
    deleteAccountTitle: 'Konto endgültig löschen?',
    deleteAccountDescription: 'Möchten Sie Ihr Konto bei IhreApotheken.de wirklich endgültig löschen? Wenn Sie “Konto löschen” auswählen, erhalten Sie eine E-Mail mit einem Bestätigungslink.',
    back: 'Zurück',
    updateHere: 'Hier können Sie Ihr Passwort aktualisieren.',
    newPassword: 'Neues Passwort',
    notice: 'Hinweis: ',
    passwordConstraint: 'Das Passwort muss mindestens 8 Zeichen lang sein und 1 Großbuchstaben, 1 Kleinbuchstaben und 1 Zahl enthalten',
    repeatPassword: 'Neues Passwort bestätigen',
    update: 'Aktualisieren',

    form: {
      salutation: 'Anrede',
      firstName: 'Vorname',
      lastName: 'Nachname',
      streetName: 'Straße',
      houseNumber: 'Hausnummer',
      zipCode: 'PLZ',
      cityName: 'Ort',
      mobileNumber: 'Mobilnummer',
      phoneNumber: 'Telefonnummer',

      fillNecessary: '* Bitte füllen Sie die Pflichtfelder aus',
      ourPromise: '{strongText} Wir nutzen die Telefonnummer nur für eventuelle Rückfragen der Apotheke zu Ihren Vorbestellungen. Außerdem werden Sie per SMS und E-Mail über den Status Ihrer Bestellung informiert.',
      ourPromiseTitle: 'Unser Versprechen:',

      cancel: 'Abbrechen',
      update: 'Aktualisieren',

      emailInUse: 'Diese E-Mail-Adresse ist bereits mit einem IhreApotheken-Konto verknüpft.',
      wrongPassword: 'Das Passwort ist nicht korrekt. Bitte versuchen Sie es erneut.',
    },
    whatsApp: {
      title: 'WhatsApp Beratung',
      agreement: 'WhatsApp Kommunikation zustimmen',
      agreementDescription: 'Ich stimme zu, dass meine Telefonnummer für die Kommunikation per WhatsApp genutzt wird. Ich kann diese Einwilligung jederzeit widerrufen. Die Datenschutzbestimmungen habe ich zur Kenntnis genommen.',
    },
  },
  ordersPage: {
    backToOverview: 'Zurück zur Übersicht',
    allProducts: 'Alle Bestellungen',
    prescriptions: 'Rezepte',
    coPaymentOpen: 'Zuzahlung offen',
  },
  deleteAccount: {
    title: 'Ihr Konto wurde erfolgreich gelöscht',
    paragraph: 'Wir bedauern sehr, dass Sie Ihr Konto bei IhreApotheken.de gelöscht haben. Wir\nwürden uns freuen, Sie bald wieder bei IhreApotheken.de begrüßen zu dürfen.',
    registerNow: 'jetzt registrieren',
  },
  addresses: {
    newAddress: 'Neue Adresse',
    deliveryAddress: 'Lieferadresse',
    paymentAddress: 'Rechnungsadresse',
    update: 'Bearbeiten',
    delete: 'Löschen',
    modalDelete: 'Möchten Sie diese Adresse wirklich löschen?',
    no: 'Nein',
    yes: 'Ja, löschen',
    loadMoreDelivery: 'Mehr Lieferadressen',
    loadMorePayment: 'Mehr Rechnungsadresse',
  },
  pharmacyInfo: {
    yourSelectedPharmacy: 'Ihre ausgewählte Apotheke',
    contactInfo: 'Kontaktinformationen',
    email: 'E-Mail Adresse',
    phoneNumber: 'Telefonnummer',
    faxNumber: 'Faxnummer',
    website: 'Webseite',
    toWebsite: 'Zur Webseite',
    deliveryMethods: 'Lieferarten',
    expressDelivery: 'Express-Botendienstlieferung',
    regularDelivery: 'Botendienstlieferung',
    pickup: 'Abholung in der Apotheke',
    socialMediaText: 'Besuchen Sie uns auch auf',
    discoverProducts: 'Produkte entdecken',
    onlinePayment: 'Online-Zahlung möglich',
    noPharmacySelected: 'Keine Apotheke ausgewählt',
  },
  reorder: {
    inStock: 'Verfügbar',
    outOfStock: 'Nicht verfügbar',
    oldPrice: 'Alter Preis',
    singlePrice: 'Einzelpreis',
    totalPrice: 'Gesamtpreis',
    total: 'Summe',
    vat: '(inkl. MwSt.)',
    findPharmaciesMessage: 'Apotheken mit allen Produkten finden',
  },
  epaper: {
    title: 'E-Paper Abonnement',
    description: 'Ihr my life E-Paper Abonnement ist aktiv. Klicken Sie auf den Button “Zum Magazin”, um sich direkt zu der aktuellen my life Ausgabe als E-Paper zu navigieren. Unter der “E-Ppaper-Übersicht” finden sie auch ältere Ausgaben der my life.',
    unsubscribedDescription: 'Alle my life Magazine gibt es jetzt auch als E-Paper. So bleiben Sie jederzeit und überall top informiert!',
    toMagazine: 'Zum Magazin',
    toEpaperOverview: 'E-Paper-Übersicht',
    subscribe: 'Kostenlos abonnieren',
    unsubscribe: 'Abonnement kündigen',
  },
  cart: {
    title: 'Ihr Warenkorb',
    info: {
      mixedCart: 'Sie haben noch {productsCount} {product} und {prescriptionCount} {prescription} in Ihrem Warenkorb',
      onlyRegularProducts: 'Sie haben noch {productsCount} {product} in Ihrem Warenkorb',
      onlyPrescriptions: 'Sie haben noch {prescriptionCount} {prescription} in Ihrem Warenkorb',
    },
    description: 'Bitte beachten Sie, dass Ihr Warenkorb sich automatisch leert, wenn Sie die Apotheke wechseln oder sich von Ihrem Benutzerkonto abmelden!',
    cartType: {
      product: 'Produkt',
      products: 'Produkte',
      prescription: 'Rezept',
      prescriptions: 'Rezepte',
    },
  },
  dataSharingPage: {
    title: 'Datenfreigabe für Apotheken',
    description: 'Apotheken, mit denen Sie aktiv interagieren – etwa durch das Vorbestellen von Produkten, das Einlösen von Rezepten oder die Buchung von Terminen – erhalten Zugriff auf Ihre Stammdaten sowie auf die zugehörigen Vorbestellungen, Rezepte und Termine. Mit dieser Freigabe stellen Sie den Apothekern alle notwendigen Informationen zur Verfügung, um Sie bestmöglich im Rahmen Ihres Besuchs beraten zu können. Selbstverständlich können Sie die Freigabe jederzeit eigenständig widerrufen. Falls Sie nach dem Widerruf erneut bei der Apotheke bestellen, wird der Zugriff automatisch wiederhergestellt, sodass Ihre Bestellung von der Apotheke bearbeitet werden kann.',
    lastOrderLabel: 'Letzte Bestellung',
    isGrantedToggle: 'Datenfreigabe erteilt',
    removePharmacy: 'Apotheke entfernen',
    noPharmacies: 'Aktuell hat keine Apotheke Zugriff auf Ihre Daten.',
    modalRemovePharmacy: {
      title: 'Wollen Sie die Apotheke aus Ihrem Profil entfernen?',
      description: 'Die Apotheke kann bei Bedarf zu einem späteren Zeitpunkt erneut hinzugefügt werden.',
      confirm: 'Apotheke entfernen',
      cancel: 'Zurück',
    },
    button: 'Zum Warenkorb',
  },
  confirmDataSharingPage: {
    error: {
      title: 'Der Link ist leider abgelaufen',
      description: 'Bitte kontaktieren Sie Ihre Apotheke für eine erneute Verknüpfung mit Ihrem Account.',
    },
    success: {
      title: 'Ihre Kundendaten sind freigegeben!',
      description: 'Ihre Apotheke kann Sie nun bestmöglich zu Ihrer Gesundheit beraten.',
    },
    buttons: {
      goToStartpage: 'Zurück zur Startseite',
      goToDataSharing: 'Zur Datenfreigabe',
    },
  },
}

export default myAccount
